import * as ng from 'angular';
import { BaseUrlService } from '../../../services/base-url.service';
import { rabbitMQ } from '../../../third/rabbitMQ';
import { googleAPI } from '../../../third/googleAPI';
import { StorageService } from '../../../services/storage.service';
import { UserService } from '../../../services/user.service';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { ValidationService } from '../../../services/validation.service';

export class ActivationCodeRenewController implements ng.IController {
    static $inject: string[] = [
        '$rootScope',
        '$scope',
        '$state',
        'ArchiSmallServices',
        'store',
        '$uibModal',
        'BaseUrlService',
        'configuration',
        '$http',
        '$timeout',
        '$sce',
        '$parse',
        '$filter',
        'user',
        'ValidationService',
        'StorageService',
        'UserService'
    ];

    constructor(
        private $rootScope: any,
        private $scope: any,
        private $state: ng.ui.IStateService,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private baseUrlService: BaseUrlService,
        private configuration: any, // todo specificare il tipo
        private $http: ng.IHttpService,
        private $timeout: ng.ITimeoutService,
        private $sce: ng.ISCEService,
        private $parse: ng.IParseService,
        private $filter: ng.IFilterService,
        private user: any, // todo cambiare
        private ValidationService: ValidationService,
        private StorageService: StorageService,
        private UserService: UserService
    ) {

        $('#rinnova-codice-attivatione .input-code').on('input', () => {
            var text = $(this).val().toString().replace(/\s/g, '').replace(/-/g, '').split('-').join(''); // remove hyphens
            if (text.length > 0) {
                text = text.match(new RegExp('.{1,5}', 'g')).join('-');
            }

            this.verifyCode(text);
            $(this).val(text);
        });
        $scope.renewSubscription = () => {
            ArchiSmallServices.renewSubscription()
                .then((response) => {
                    $state.go('usersettings.rinnova-offerta-summary');
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
    }

    private verifyCode(text: string): void {
        if (text.toUpperCase() === 'CWH10-SDCHH-5513D-44DFL') {
            $('#code-validated').removeClass('hidden');
            $('#code-invalid').addClass('hidden');
            $('#entra-archismall').removeClass('hidden');
        } else if (text.toUpperCase() !== '') {
            $('#code-validated').addClass('hidden');
            $('#code-invalid').removeClass('hidden');
            $('#entra-archismall').addClass('hidden');
        }
    }
}


export const ActivationCodeRenewComponent: ng.IComponentOptions = {
    template: require('./rinnova-codice-attivazione.html'),
    controller: ActivationCodeRenewController
};







// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/rinnova-codice-attivazione/rinnova-codice-attivazione.ts